export default __webpack_public_path__ + "static/P_SearchThumb_IN-9020HD-3e2c33c2c96f74bc0bcbd4eb17e72b8a.webp";